import React from 'react';
import PropTypes from 'prop-types';
import style from './WmsCollapse.scss';

class WmsCollapse extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded: props.isExpanded
        }
        this.headerClickNamespace = "click.wmsCollapse." + props.id;
        this.mainNode = null;
        this.headerNode = null;
        this.headerInfoNode = null;
    }
    setMainRef = (node) => {
        this.mainNode = node;
        const divRefs = this.props.divRefs;
        if (typeof divRefs === 'function') {
            divRefs(node);
        } else if (divRefs && typeof divRefs === 'object') {
            divRefs.current = node;
        }
    }
    setHeaderRef = (node) => {
        this.headerNode = node;
    }
    setHeaderInfoRef = (node) => {
        this.headerInfoNode = node;
    }
    componentDidMount() {
        // Bind on this header node (not React onClick, and not $("#id")).
        // React root delegation misses clicks after Kendo Window reparents the
        // modal outside #root. A document id lookup binds the first match only,
        // so a second open window that reuses the same section id never toggles.
        if (this.headerNode) {
            $(this.headerNode).on(this.headerClickNamespace, this.onClickEvent);
        }

        if (this.props.isShowTooltip) {
            this.tooltipTimer = setTimeout(() => {
                if (!this.mainNode) {
                    return;
                }
                $(this.mainNode).kendoTooltip({
                    width: 240,
                    position: "bottom",
                    content: (e) => {
                        return '<p class="model-tooltip-title-p">' + this.props.tooltipText + '</p>';
                    },
                    animation: {
                        open: {
                            effects: "zoom",
                            duration: 150
                        }
                    }
                }).data("kendoTooltip");
            }, 100);
        }
        if (this.props.isShawHeaderInfoIcon) {
            this.headerInfoTimer = setTimeout(() => {
                if (!this.headerInfoNode) {
                    return;
                }
                $(this.headerInfoNode).kendoTooltip({
                    width: 240,
                    showAfter: 500,
                    position: "bottom",
                    content: (e) => {
                        return '<p class="model-tooltip-title-p">' + this.props.headerInfoTooltipText + '</p>';
                    },
                    animation: {
                        open: {
                            effects: "zoom",
                            duration: 150
                        }
                    }
                }).data("kendoTooltip");
            }, 100);
        }
    }
    componentWillUnmount() {
        clearTimeout(this.tooltipTimer);
        clearTimeout(this.headerInfoTimer);
        if (this.headerNode) {
            $(this.headerNode).off(this.headerClickNamespace);
        }
    }
    onClickEvent = (e) => {
        if (this.props.showCollapseText == false && this.props.showCollapseIcon == false) {
            return;
        }
        var header = $(e.currentTarget);
        var content = header.next(".wms-collapsible-content");
        if (!content.length) {
            content = header.next();
        }
        content.slideToggle(500, () => {
            this.setState({
                isExpanded: !this.state.isExpanded
            });
        });
        this.props.setCollapseMetaData(this.state.isExpanded);
    }

    render() {
        return (
            <div className={"wms-collapsible-div " + (this.props.isDisabled ? "wms-collapse-disabled" : "")} id={this.props.id + '_main'} ref={this.setMainRef}>
                <div className="wms_collapsible_header" id={this.props.id} ref={this.setHeaderRef}>
                    <div className='title-info'>
                        <label className="wms-title">{this.props.headerLabel}</label>
                        {this.props.isShawHeaderInfoIcon && (
                            <span className="fa fa-info-circle" id={this.props.id + '_headerinfo'} ref={this.setHeaderInfoRef} aria-hidden="true"></span>
                        )}
                    </div>
                    {this.props.showDragIcon && (
                        <span className="wms-sort"><i className="fas fa-arrows-alt-v"></i></span>
                    )}
                    {!this.props.showCollapseText && this.props.showCollapseIcon &&
                        <label className={'icon_label '}>{this.state.isExpanded ? <i className="fa fa-chevron-up" aria-hidden="true"></i> : <i className="fa fa-chevron-down" aria-hidden="true"></i>} </label>
                    }
                    {this.props.showCollapseText &&
                        <label className={'icon_label label-text-padding '}>{this.state.isExpanded ? '- Collapse' : '+ Expand'} </label>
                    }
                </div>
                <div className="wms-collapsible-content" style={{ display: this.state.isExpanded ? 'block' : 'none' }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

WmsCollapse.propTypes = {
    id: PropTypes.string.isRequired, // this should write the id to the input
    windowId: PropTypes.string, // this should window id
    headerLabel: PropTypes.string.isRequired, // this should be the label that default shows whether it is collapse or expand,
    showDragIcon: PropTypes.bool, // set true to saw drag icon on header left side by default is true
    showCollapseIcon: PropTypes.bool,
    isExpanded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isShawHeaderInfoIcon: PropTypes.bool,
    ref: PropTypes.any
}
WmsCollapse.defaultProps = {
    isExpanded: true,
    isDisabled: false,
    showCollapseText: true,
    showDragIcon: false,
    showCollapseIcon: true,
    isShowTooltip: false,
    tooltipText: '',
    isShawHeaderInfoIcon: false,
    headerInfoTooltipText: '',
    ref: '',
    setCollapseMetaData: (e) => function () { },
    windowId: ""
}
export default WmsCollapse;
